import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './styles/global.css'
import posthog from 'posthog-js'

posthog.init(process.env.VUE_APP_POSTHOG_TOKEN || '', {
  api_host: process.env.VUE_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
  defaults: '2026-01-30',
})

Vue.prototype.$posthog = posthog

Vue.config.errorHandler = (err) => {
  posthog.captureException(err)
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
